import { render, staticRenderFns } from "./SecondStep.vue?vue&type=template&id=4cca1d0c&scoped=true&"
import script from "./SecondStep.vue?vue&type=script&lang=js&"
export * from "./SecondStep.vue?vue&type=script&lang=js&"
import style0 from "./SecondStep.vue?vue&type=style&index=0&id=4cca1d0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cca1d0c",
  null
  
)

export default component.exports